import { render, staticRenderFns } from "./OrderSingleSummaryItems.vue?vue&type=template&id=a4cd784e&"
import script from "./OrderSingleSummaryItems.vue?vue&type=script&lang=js&"
export * from "./OrderSingleSummaryItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports